/*=============================
=             Menu            =
=============================*/

var menu = document.getElementById('menu'),
	mobileMenuButton = document.getElementById('mobile-menu-button');

body.addEventListener('click', function(e) {
	checkAndCloseMenu(e.target);
});

document.addEventListener('keydown', function(e) {
	if(e.key == 'Escape')
		checkAndCloseMenu(menu);
});

function checkAndCloseMenu(e) {
	var open = openMenu(e);

	if(open) {
		closeMenu(open);
		toggleMenuBodyClass(false);
	}
}

[].slice.call(document.querySelectorAll('#cta-links button:not(.lang-button), #nav-wrap button:not(.lang-button):not(#search-button)')).forEach(function(navLink) {
	navLink.addEventListener('click', toggleMenu);
});

function toggleMenu() {
	closeMenu(openMenu(this));

	var parent = this.parentNode.parentNode,
		openSibling = parent.querySelector('.open'),
		isOpen = this.classList.contains('open'),
		animation = checkWidth(1200) ? (isOpen ? 'slideUp' : 'slideDown') : (isOpen ? 'fadeOut' : 'fadeIn'),
		display = isOpen ? 'none' : (this == mobileMenuButton ? 'flex' : 'block');

	if(parent.classList.contains('submenu') && openSibling && openSibling != this)
		closeMenu(openSibling);

	Velocity(this.nextElementSibling, animation, {duration: 300, display: display});

	var mobileMenuText = mobileMenuButton.querySelector('.mobile-menu-text');
	mobileMenuText.textContent = isOpen ? 'Menu':'Close';


	this.classList.toggle('open');

	this.setAttribute('aria-expanded', (this.getAttribute('aria-expanded') == 'true' ? 'false' : 'true'));

	toggleMenuBodyClass(header.querySelector('.open'));
}

function closeMenu(el) {
	if(el) {
		var submenu = el.nextElementSibling;

		Velocity(submenu, checkWidth(1200) ? 'slideUp' : 'fadeOut', {duration: 300});

		el.classList.remove('open');

		closeMenu(submenu.querySelector('.open'));
	}
}

function openMenu(el) {
	var openButton = header.querySelector('.open:not(#mobile-menu-button)');

	return openButton && !openButton.parentNode.contains(el) ? openButton : false;
}

function toggleMenuBodyClass(open) {
	if(open)
		body.classList.add('menu-open');
	else
		body.classList.remove('menu-open');

	setFocus((open ? true : false), header);
}

window.setFocus = function setFocus(open, container) {
	[].slice.call(document.querySelectorAll('#header, #hero, #main, #footer')).forEach(function(parent) {
		if(parent != container) {
			parent.setAttribute('aria-hidden', open);

			[].slice.call(parent.querySelectorAll('a, button, input')).forEach(function(link) {
				if(open)
					link.setAttribute('tabindex', '-1');
				else
					link.removeAttribute('tabindex');
			});
		}
	});
}
